module.exports = __webpack_public_path__ + "static/media/About-us.c55b9de2.png";